import '../Navbar/Navbar.css'
import {Link } from 'react-router-dom'

const Navtab3 = () => {
return<>
    <li className="nav-item dropdown custom-margin1">
    <a className="nav-link dropdown-toggle" href=" " role="button" data-bs-toggle="dropdown" aria-expanded="false" style = {{color: 'white'}}>
      Register
    </a>
    <ul className="dropdown-menu">
    <li><a className="dropdown-item" href=" "><Link to='/agronomist'><button className='btn'> Agronomist</button></Link></a></li>
      <li> <hr className="dropdown-divider"/> </li>
      <li><a className="dropdown-item" href=" "><Link to='/farmcompany'><button className='btn'>Farming Company</button></Link></a></li>
    
    </ul>
  </li>
  </>
};
export default Navtab3;